module.exports = __webpack_public_path__ + "img/f.f0a0500b.jpg";